import MUITab from '@mui/material/Tab';
import { ReactElement } from 'react';

type TabProps = {
  'aria-controls'?: string;
  'data-testid'?: string;
  disabled?: boolean;
  disableFocusRipple?: boolean;
  disableRipple?: boolean;
  icon?: string | ReactElement;
  iconPosition?: 'bottom' | 'end' | 'start' | 'top';
  id?: string;
  label?: React.ReactNode;
  sx?: any;
  value?: any;
  wrapped?: boolean;
};
const Tab = (props: TabProps) => {
  return <MUITab {...props} />;
};

export default Tab;
